jQuery(document).ready(function() {
	initSetupNav();
});

// Initialize main navigation menu and menu behaviors
function initSetupNav() {
	jQuery('#main-menu__items').smartmenus({
		subIndicatorsPos: 'append',
		subMenusMinWidth: '100%',
		showFunction: function($ul, complete) { $ul.slideDown(200, complete); },
		hideFunction: function($ul, complete) { $ul.slideUp(200, complete); },
		bottomToTopSubMenus: false
	});

	// Menu behaviors 
	var $mainMenuState = jQuery('#main-menu__state');
	if ($mainMenuState.length) {
		$mainMenuState.change(function(e) {
			var $menu = jQuery('#main-menu__items');
			if (this.checked) {
				$menu.hide().slideDown(250, function() { $menu.css('display', ''); });
			} else {
				$menu.show().slideUp(250, function() { $menu.css('display', ''); });
			}
		});
		// Hide mobile menu when window is unloaded 
		// (prevents the menu from being shown on refresh)
		jQuery(window).bind('beforeunload unload', function() {
			if ($mainMenuState[0].checked) {
				$mainMenuState[0].click();
			}
		});
	}
}

jQuery('ul.collapsible-section').on('click', 'a.collapsible-header', function(e) {
	e.preventDefault();
	jQuery(this)
		.toggleClass('active')
		.toggleClass('ss-hyphen')
		.toggleClass('ss-plus')
		.next()
			.slideToggle(200)
			.parent()
			.siblings('li')
				.find('.collapsible-content')
					.slideUp(200)
					.end()
				.find('a.ss-hyphen')
					.addClass('ss-plus')
					.removeClass('ss-hyphen')
				.find('a.collapsible-header')
					.removeClass('active');
});